import {EventEmitter, Injectable, Output } from '@angular/core';
import { environment } from './../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class MangopayService {

  mangopayAPI: object = {};
  mangopayApiLink: string = "";

	constructor(
    private httpClient: HttpClient,
  ) {}

  public async loadMangopayToken(network: string): Promise<any> {

    const result = await this.httpClient.post(`${environment.baseURL}/mangopay/getToken`, {
        network: network,
        jwt: localStorage.getItem('token')
    }).toPromise();

    const data = (result as any).data;

    this.mangopayAPI[network] = {
      clientID: data.client_id,
      oauthToken: data.oauthToken
    };
    this.mangopayApiLink = data.mangopayApiUrl;
  }

  mangopayAuth(network): object {
    console.log("this.mangopayAPI[network]", this.mangopayAPI[network]);
    const headers = {
      headers: new HttpHeaders({
        'Authorization':  `Bearer ${this.mangopayAPI[network].oauthToken}`
      })
    }

console.log("headers", headers);
    return headers;
  }

  public createNaturalUser(network: string, data: object): Observable<any> {

    const headers = this.mangopayAuth(network);

		return this.httpClient.post(`${this.mangopayApiLink + this.mangopayAPI[`${network}`].clientID}/users/natural/`, data, headers);
	}

  public updateNaturalUser(network: string, data: object, userId: string): Observable<any> {

    const headers = this.mangopayAuth(network);

		return this.httpClient.put(`${this.mangopayApiLink + this.mangopayAPI[`${network}`].clientID}/users/natural/${userId}`, data, headers);
	}

  public createWallet(network: string, data: object): Observable<any> {

    const headers = this.mangopayAuth(network);

		return this.httpClient.post(`${this.mangopayApiLink + this.mangopayAPI[`${network}`].clientID}/wallets/`, data, headers);
	}

  public createKycDocument(network: string, data: object, userId: string): Observable<any> {

    const headers = this.mangopayAuth(network);

		return this.httpClient.post(`${this.mangopayApiLink + this.mangopayAPI[`${network}`].clientID}/users/${userId}/kyc/documents/`, data, headers);
	}

  public createKycPage(network: string, data: object, mangopayIds: { userId: string, kycId: string }): Observable<any> {

    const headers = this.mangopayAuth(network);

		return this.httpClient.post(`${this.mangopayApiLink + this.mangopayAPI[`${network}`].clientID}/users/${mangopayIds.userId}/kyc/documents/${mangopayIds.kycId}/pages`, data, headers);
	}

  public submitKycDocument(network: string, data: object, mangopayIds: { userId: string, kycId: string }): Observable<any> {

    const headers = this.mangopayAuth(network);

		return this.httpClient.put(`${this.mangopayApiLink + this.mangopayAPI[`${network}`].clientID}/users/${mangopayIds.userId}/kyc/documents/${mangopayIds.kycId}`, data, headers);
	}

  public createIbanBankAccount(network: string, data: object, userId: string): Observable<any> {

    const headers = this.mangopayAuth(network);

		return this.httpClient.post(`${this.mangopayApiLink + this.mangopayAPI[`${network}`].clientID}/users/${userId}/bankaccounts/iban/`, data, headers);
	}
  public deactivateBankAccount(network: string, bankAccountId: string, userId: string): Observable<any> {

    const headers = this.mangopayAuth(network);

		return this.httpClient.put(`${this.mangopayApiLink + this.mangopayAPI[`${network}`].clientID}/users/${userId}/bankaccounts/${bankAccountId}/`, { Active: false }, headers);
	}
}
